function injectStyle (ssrContext) {
  require("!!../../../../extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true,\"publicPath\":\"../../\"}!vue-style-loader!css-loader?{\"sourceMap\":true}!../../../../vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-d7d30802\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../vux-loader/src/after-less-loader.js!less-loader?{'modifyVars':{'brand':'#FEAA33','danger':'#FB5046','dark-gary':'#696969','success':'#37bc9b','white':'#ffffff','theme-color':'@brand','tabbar-text-active-color':'@brand','radio-checked-icon-color':'@brand','number-button-font-color':'@brand','badge-bg-color':'@danger','button-default-bg-color':'#F2F2F2','button-primary-bg-color':'@success','button-warn-bg-color':'@danger','button-default-font-color':'@dark-gary','icon-success-color':'@success','icon-warn-color':'@danger','popup-background-color':'@white','search-cancel-font-color':'@brand','button-plain-default-border-color':'#CDCDCD','checklist-icon-active-color':'@brand','cell-font-size':'14px','button-global-height':'48px','popover-bg-color':'rgba(30, 30, 30, 0.9)','button-tab-active-background-color':'#fff','button-tab-active-font-color':'@brand','button-tab-default-text-color':'#333'},'sourceMap':true}!../../../../vux-loader/src/style-loader.js!../../../../vue-loader/lib/selector?type=styles&index=0!./index.vue")
}
var normalizeComponent = require("!../../../../vue-loader/lib/component-normalizer")
/* script */
export * from "!!babel-loader!../../../../vux-loader/src/script-loader.js!../../../../vux-loader/src/script-loader.js!../../../../vue-loader/lib/selector?type=script&index=0!./index.vue"
import __vue_script__ from "!!babel-loader!../../../../vux-loader/src/script-loader.js!../../../../vue-loader/lib/selector?type=script&index=0!./index.vue"
/* template */
import __vue_template__ from "!!../../../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-d7d30802\",\"hasScoped\":false,\"transformToRequire\":{\"video\":\"src\",\"source\":\"src\",\"img\":\"src\",\"image\":\"xlink:href\"},\"buble\":{\"transforms\":{}}}!../../../../vux-loader/src/before-template-compiler-loader.js!../../../../vux-loader/src/template-loader.js!../../../../vue-loader/lib/selector?type=template&index=0!./index.vue"
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/vux/src/components/icon/index.vue
// module id = null
// module chunks = 